import type { DropzoneOptions } from 'react-dropzone';

export interface UploadConstraints {
  readonly accept: NonNullable<DropzoneOptions['accept']>;
  readonly mimeTypes: readonly string[];
  readonly extensions: readonly string[];
  readonly maxSize: number;
}

export const DOCUMENT_UPLOAD = {
  accept: {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/heic': ['.heic'],
    'image/tiff': ['.tif', '.tiff'],
    'application/pdf': ['.pdf'],
  },
  mimeTypes: ['image/jpeg', 'image/png', 'image/heic', 'image/tiff', 'application/pdf'],
  extensions: ['.jpg', '.jpeg', '.png', '.heic', '.tif', '.tiff', '.pdf'],
  maxSize: 25 * 1024 * 1024,
} as const satisfies UploadConstraints;

export const ASSET_UPLOAD = {
  accept: {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
  },
  mimeTypes: ['image/jpeg', 'image/png'],
  extensions: ['.jpg', '.jpeg', '.png'],
  maxSize: 5 * 1024 * 1024,
} as const satisfies UploadConstraints;

export function resolveMimeTypeFromFilename(filename: string, constraints: UploadConstraints): string | undefined {
  const extensionStart = filename.lastIndexOf('.');
  if (extensionStart < 0) return undefined;

  const extension = filename.slice(extensionStart).toLowerCase();
  if (!constraints.extensions.includes(extension)) return undefined;

  return Object.entries(constraints.accept).find(([, extensions]) =>
    extensions.some((allowedExtension) => allowedExtension.toLowerCase() === extension)
  )?.[0];
}
